import { BaseOption } from './base-option';

export class ComparabilityStatus extends BaseOption { }
